<template>
  <n-card class="module module--empty">
    <n-grid
      :cols="6"
      x-gap="24"
      y-gap="24"
    >
      <n-grid-item :span="6">
        <n-space
          align="center"
          :wrap-item="false"
        >
          <Icon
            icon="mdi:information-outline"
            :style="{ fontSize: '24px' }"
          />
          <h4 class="module-title">{{ t('modules.noModules.index') }}</h4>
        </n-space>
      </n-grid-item>

      <n-grid-item :span="6">
        {{ t('modules.noModules.content') }}
      </n-grid-item>
    </n-grid>
  </n-card>
</template>

<script setup lang="ts">
import { NCard, NSpace, NGrid, NGridItem } from 'naive-ui'
import { Icon } from '@iconify/vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.module-title {
  margin-bottom: 0;
}
.module--empty {
  background-color: transparent;
  border: 2px dashed #858585;
}
</style>
